import React from "react";
import { useSearchParams } from "react-router-dom";
import { updateQueryParams } from "utils/queryParamsHelper";

const useSearchHook = (defaultSearch = "") => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialSearch = searchParams.get("search") || defaultSearch;
  const [searchValue, setSearchValue] = React.useState(initialSearch);

  const onSearch = (value: any) => {
    setSearchValue(value);
    updateQueryParams({ search: value }, setSearchParams);
  };

  return {
    searchValue,
    onSearch,
  };
};

export default useSearchHook;
